import { DateTime } from "luxon";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

import { fetchTherapistsAvailabilityForDay } from "../../../services/api/therapists";
import {
  actionCreators as therapistsActions,
  fetchTherapistsSearch,
} from "../../../store/therapists/actions";
import { actionCreators as postcodeActions } from "../../../store/postcodes/actions";
import { actionCreators as categoryActions } from "../../../store/categories/actions";
import { dateFromIso } from "../../../utils/dateIso";
import {
  fetchCategories,
  ICategory,
} from "../../../services/api/category-list";

export const LandingProxyPage = (): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { categoryName, districtCode } = useParams();

  useEffect(() => {
    const getFirstAvailableDate = async (): Promise<string | undefined> => {
      const DAYS_AHEAD = 2;
      const currentDate = DateTime.local();

      for (let i = 0; i <= DAYS_AHEAD; i++) {
        const date = DateTime.local().plus({ days: i });
        const slots = await fetchTherapistsAvailabilityForDay({
          category: categoryName,
          day: date.toISODate(),
          outcode: districtCode,
        });

        for (const slot of slots) {
          const slotDate = dateFromIso(slot);

          if (slotDate > currentDate) {
            return slotDate.toISO();
          }
        }
      }

      return undefined;
    };

    const getSelectedCategory = async (): Promise<ICategory | undefined> => {
      const categories = await fetchCategories();

      return categories.find(
        ({ name }) => name.toLowerCase() === categoryName.toLowerCase(),
      );
    };

    getSelectedCategory().then((category) => {
      if (typeof category === "undefined") {
        history.replace("/");
        return;
      }

      getFirstAvailableDate().then((isoDate) => {
        if (typeof isoDate === "undefined") {
          history.replace("/");
          return;
        }

        dispatch(therapistsActions.clearDate());
        dispatch(therapistsActions.clearAdditionalTherapists());
        dispatch(therapistsActions.deSelectTherapist());
        dispatch(therapistsActions.clearTherapists());
        dispatch(postcodeActions.clearAddress());
        dispatch(categoryActions.clearCategory());

        dispatch(categoryActions.setCategory(category));
        dispatch(therapistsActions.setDate(isoDate));
        dispatch(
          fetchTherapistsSearch({
            availableAt: isoDate,
          }),
        );

        history.replace(
          `/category/${categoryName}/therapists?outcode=${districtCode}&date=${isoDate}`,
        );
      });
    });
  }, []);

  return <></>;
};
